<template>
  <form-block :title="title !== null ? title : tr('Demographic targeting')">
    <p v-if="targetAudienceBlockIsLoading" class="m-0 flex items-center gap-2 text-muted-foreground">
      <loader-circle-icon class="size-4 animate-spin" />
      {{ tr('Loading...') }}
    </p>

    <template v-else>
      <div v-if="genderAvailable" class="flex flex-col gap-1.5">
        <ui-label>{{ tr('Gender') }}</ui-label>
        <gender-selector v-model="entity.settings.adset_targeting.genders" :disabled="disabled" />
      </div>
      <info-text v-if="genderMessage" :type="genderMessageType || 'info'">
        {{ genderMessage }}
      </info-text>

      <div v-if="ageAvailable" class="flex flex-col gap-1.5">
        <ui-label>{{ tr('Age') }}</ui-label>
        <div class="flex items-center gap-2.5">
          <age-selector v-model="entity.settings.adset_targeting.age_min" :disabled="disabled" />
          –
          <age-selector v-model="entity.settings.adset_targeting.age_max" :disabled="disabled" />
        </div>
      </div>
      <info-text v-if="ageMessage" :type="ageMessageType || 'info'">
        {{ ageMessage }}
      </info-text>
    </template>
  </form-block>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import AgeSelector from '@/ui/components/AgeSelector.vue';
import GenderSelector from '@/ui/components/GenderSelector.vue';
import InfoText from '@/ui/components/InfoText.vue';

export default {
  name: 'DemographicTargetBlock',
  components: {
    AgeSelector,
    GenderSelector,
    InfoText,
    LoaderCircleIcon: LoaderCircle,
  },
  mixins: [ RuleFormBlockMixin ],
  props: {
    title: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
    targetAudienceBlockIsLoading: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    ageAvailable: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    ageMessage: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
    ageMessageType: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
    genderAvailable: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    genderMessage: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
    genderMessageType: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
  },
  methods: {
    validate() {
      return true;
    },
  },
};
</script>
